"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const preact_1 = require("preact");
const hooks_1 = require("preact/hooks");
const preact_custom_element_1 = __importDefault(require("preact-custom-element"));
const assets_1 = require("../lib/assets");
const video_1 = require("../hooks/video");
function VideoPlayer({ src, poster }) {
    const [playing, videoRef, videoProps] = (0, video_1.useVideo)();
    const [progress, setProgress] = (0, hooks_1.useState)(0);
    function play() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            return (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.play();
        });
    }
    function pause() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            return (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.pause();
        });
    }
    function handleTimeUpdate() {
        const video = videoRef.current;
        if (!video) {
            return;
        }
        setProgress((video.currentTime / video.duration) * 100);
    }
    return ((0, preact_1.h)("div", { className: 'video  stack' },
        (0, preact_1.h)("img", { src: (0, assets_1.asset)('images/placeholder/video.svg'), alt: '', width: 160, height: 90, className: 'video__placeholder' }),
        (0, preact_1.h)("video", Object.assign({ ref: videoRef, src: src, width: 1280, height: 720, playsInline: true, onTimeUpdate: handleTimeUpdate, className: 'video__embed' }, videoProps)),
        playing ? ((0, preact_1.h)("div", { className: 'video__controls' },
            (0, preact_1.h)("div", { className: 'progress  video__progress' },
                (0, preact_1.h)("div", { className: 'progress__indicator', style: { width: `${progress}%` } })),
            (0, preact_1.h)("button", { type: 'button', onClick: pause, className: 'video__pause' },
                (0, preact_1.h)("svg", { viewBox: '0 0 44 44', width: 44, height: 44, fill: '#fff' },
                    (0, preact_1.h)("rect", { x: 14, y: 13, width: 4, height: 18, rx: 2, ry: 2 }),
                    (0, preact_1.h)("rect", { x: 24, y: 13, width: 4, height: 18, rx: 2, ry: 2 }))))) : ((0, preact_1.h)("button", { type: 'button', onClick: play, className: 'video__button' },
            (0, preact_1.h)("img", { src: (0, assets_1.asset)('images/play.svg'), alt: 'Play', width: 512, height: 512, className: 'video__icon' })))));
}
exports.default = VideoPlayer;
(0, preact_custom_element_1.default)(VideoPlayer, 'sarsons-video', [
    'src',
    'poster',
]);
